import { ChangeDetectionStrategy, Component, OnInit, ViewEncapsulation, inject, PLATFORM_ID, Inject, ChangeDetectorRef } from '@angular/core';
import { Router, RouterModule, NavigationEnd, ActivatedRoute } from '@angular/router';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { BreakpointObserver } from '@angular/cdk/layout';
import { UserService } from '../../../services/user.service';
import { EventService } from '../../../services/event.service';
import { filter, map, mergeMap } from 'rxjs/operators';
@Component({
  selector: 'wire-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: true,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterModule, CommonModule],
})
export class FooterComponent implements OnInit {
  public userService = inject(UserService);
  private readonly eventService = inject(EventService);
  private readonly breakpointObserver = inject(BreakpointObserver);
  private readonly cdr = inject(ChangeDetectorRef);
  private readonly activatedRoute = inject(ActivatedRoute);
  private readonly router = inject(Router);

  public user = this.userService.currentUser;
  public currentEvent = this.eventService.currentEvent;
  isMobile: boolean = false;
  footerDisplayed: boolean = false;
  constructor(@Inject(PLATFORM_ID) private readonly platformId: Object) { }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.breakpointObserver.observe([
        '(max-width: 768px)'
      ]).subscribe(result => {
        this.isMobile = result.matches;
        this.cdr.detectChanges();
      });
    }
    this.subscribeToRouteData();

  }
  subscribeToRouteData() {
    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd),
      map(() => {
        let route = this.activatedRoute;
        while (route.firstChild) {
          route = route.firstChild;
        }
        return route;
      }),
      mergeMap(route => route.data)
    ).subscribe(data => {
      this.footerDisplayed = data['footer'] ?? false;
      this.cdr.detectChanges();
    });
  }
}